import React from 'react';
import {ImageUploader} from '../uploaders';
import LayerData from './layer-data';
import './stage-editor.css';

/** @class ImageLayerData
 * A component for editing image layer-specific properties.
 */
export default class ParallaxLayerData extends LayerData {
  /** @function render
    * Renders the component.
    */
  render(){
    return (
      <div className="dialog-content">
        <h3 className="header">Parallax Layer</h3>
        <div className="input-group">
          <label htmlFor="name">Name</label><br/>
          <input type="text" name="name"
            value={this.state.name}
            onChange={this.handleChange}
            onBlur={this.handleBlur}
            />
        </div>
        <div className="input-group">
          <label htmlFor="x">X</label><br/>
          <input name="x" type="number"
            value={this.state.x}
            onChange={this.handleIntChange}
            onBlur={this.handleBlur}
            />
        </div>
        <div className="input-group">
          <label htmlFor="y">Y</label><br/>
          <input name="y" type="number"
            value={this.state.y}
            onChange={this.handleIntChange}
            onBlur={this.handleBlur}
            />
        </div>
        <div className="input-group">
          <label htmlFor="ratio">Ratio</label><br/>
          <input name="ratio" type="number"
            value={this.state.ratio}
            onChange={this.handleFloatChange}
            onBlur={this.handleBlur}
            step={0.1}
            min={0}
            max={1}
            />
        </div>
        <div className="input-group">
          <ImageUploader
            name="Parallax Image"
            value={this.state.image}
            dataURL={this.props.dataURL}
            onUpload={(url) => this.handleImageUpload("image", url)}
            />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/stage-editor/parallax-layer-data.js